
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom'; // Step 1: Import Link
import './App.css';

const data = [
  {
    image: "./images/sigiriya.png",
    title: "SRI LANKA",
    description: "Kandy is a cultural gem nestled in the heart of Sri Lanka’s central hills. Known for the sacred Temple of the Tooth Relic and the annual Esala Perahera festival, ",
    link: "/srilankatours"
  },
  {
    image: "./images/china.jpg",
    title: "CHINA",
    description: "Relax on golden sands, swim in turquoise waters, and soak up the sunshine at top beach spots.",
    link: "/chinatours"
  },

];

const InfoSection = () => {
  return (
    <div className="info-section">

    <div className="cover-photo-container">
            <img src="/images/servicecover.png" className="cover-photo" />
    </div>

      {/* Heading */}
      <h2 className="section-main-heading"><strong> - Tour Planning - </strong> <br/>Explore Your Favourite Destination</h2>
      <div className="info-section2">
      <p className="section-main-para">Embark on an unforgettable journey with us as we help you plan your dream vacation. Whether you're drawn to the serene beaches, lush hills, and cultural richness of Sri Lanka, or the majestic landscapes, ancient wonders, and vibrant cities of China, we've got you covered.<br/><br/>
                                        Our tour planning service offers personalized experiences tailored to your interests and travel style. Discover the spiritual heritage of Sri Lanka, from the Temple of the Tooth to the scenic beauty of Ella, or explore the Great Wall, Forbidden City, and the modern marvels of Shanghai in China.<br/><br/>
                                        Let us make your travel dreams come true, your next adventure begins here!</p>
</div>
      {/* Grid of destination boxes */}
      <div className="box-row">
        {data.map((item, index) => (
          <div className="info-box2" key={index}>
            <h3 className="info-title">{item.title}</h3>
            <div className="info-image-wrapper">
              <img src={item.image} className="info-image" />
            </div>
            <div className="info-content2">
              <Link to={item.link} className="explore-button4">Explore More ...</Link>
            </div>
          </div>
        ))}

      </div>
    </div>
  );
};

export default InfoSection;
